// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"e523b76a","144":"c87746dc","429":"64ae7868","479":"a9fecb1f","532":"96c4365f","623":"fa1413f5","645":"f1bf7e65","703":"a7f6ac8e","741":"5591fc15","818":"6f21146e","840":"6fcf3007","854":"a99b4c05","867":"b8f3706a","889":"ea094077"}[chunkId] + ".chunk.js";
};